import { ref, push, set, get, remove } from 'firebase/database';
import { db } from '../lib/firebase';

export const createEstimate = async (userId: string, data: EstimateData): Promise<string> => {
  const estimatesRef = ref(db, `estimates/${userId}`);
  const newEstimateRef = push(estimatesRef);
  
  const estimateData = {
    ...data,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    status: 'draft'
  };
  
  await set(newEstimateRef, estimateData);
  return newEstimateRef.key as string;
};

export const getEstimates = async (userId: string): Promise<EstimateWithId[]> => {
  const estimatesRef = ref(db, `estimates/${userId}`);
  const snapshot = await get(estimatesRef);
  
  if (!snapshot.exists()) {
    return [];
  }
  
  return Object.entries(snapshot.val()).map(([id, data]) => ({
    id,
    ...(data as EstimateData)
  }));
};

export const getEstimate = async (userId: string, estimateId: string): Promise<EstimateData | null> => {
  const estimateRef = ref(db, `estimates/${userId}/${estimateId}`);
  const snapshot = await get(estimateRef);
  
  if (!snapshot.exists()) {
    return null;
  }
  
  return snapshot.val() as EstimateData;
};

export const updateEstimate = async (userId: string, estimateId: string, data: Partial<EstimateData>): Promise<void> => {
  const estimateRef = ref(db, `estimates/${userId}/${estimateId}`);
  await set(estimateRef, {
    ...data,
    updatedAt: new Date().toISOString()
  });
};

export const deleteEstimate = async (userId: string, estimateId: string): Promise<void> => {
  const estimateRef = ref(db, `estimates/${userId}/${estimateId}`);
  await remove(estimateRef);
};

// Ajout de la fonction saveEstimate comme export nommé
export const saveEstimate = async (userId: string, data: EstimateData): Promise<string> => {
  return createEstimate(userId, data);
};